const Setupscheduling = (() => {
    let dayOffReasonsData, dayOffReasonsTable

    function getDayOffReasonsView() {
        const frag = document.createDocumentFragment();

        dayOffReasonsTable = table.build({
            tableId: 'dayOffReasonsSetupTable', 
            columnHeadings: ['Reason'], 
            endIcon: true,
        });

        const headers = dayOffReasonsTable.querySelectorAll('.header div');
        headers[0].setAttribute('data-type', 'string');        

        const addDayOffReasonsBtnDiv = document.createElement('div');
        const addDayOffReasonsBtn = new Button({
            text: 'ADD NEW DAY OFF REASON',
            style: 'primary',
            icon: 'add',
            styleType: 'outlined',
        });

        frag.append(dayOffReasonsTable);
        if ($.session.SetupInsert) {
            addDayOffReasonsBtn.button.style.float = 'right';
            addDayOffReasonsBtn.renderTo(addDayOffReasonsBtnDiv);
            frag.append(addDayOffReasonsBtnDiv);
        }

        const tableDayOffReasonsData = dayOffReasonsData
            .map(cd => {
                return {
                    values: [cd.dayOffReasons],
                    endIcon: $.session.SetupDelete ? icons['delete'] : '',
                    onClick: e => {
                        showDayOffReasonsPopup(cd);
                    },
                    endIconCallback: () => handleDayOffReasonsDelete(cd),
                };
            });

        table.populate(dayOffReasonsTable, tableDayOffReasonsData);
        table.sortTableByHeader(dayOffReasonsTable);

        addDayOffReasonsBtn.onClick(e => {
            showDayOffReasonsPopup();
        });
        return frag;
    }

    function showDayOffReasonsPopup(rowData) {
        const popup = POPUP.build({
            classNames: 'regionPopup',
            hideX: true,
        });

        const dayOffReasonsForm = new Form({
            fields: [
                {
                    type: 'text',
                    label: 'Reason',
                    id: 'wDayOffReasons',
                    required: true,
                }                     
            ],
        });


        const inputs = ['wDayOffReasons'];
        inputs.forEach(input => {
            dayOffReasonsForm.inputs[input].onKeyup(event => {
                dayOffReasonsForm.inputs['wDayOffReasons'].setValidtyError('');
                dayOffReasonsForm.inputs['wDayOffReasons'].clearErrorOrWarning();
                checkForRequiredFields(dayOffReasonsForm); 
                if (dayOffReasonsForm.inputs['wDayOffReasons'].input.value != '' && dayOffReasonsForm.inputs['wDayOffReasons'].input.value.trim() != '') {
                    dayOffReasonsForm.buttons['submit'].toggleDisabled(false);
                } else {
                    dayOffReasonsForm.buttons['submit'].toggleDisabled(true);
                }
            });
        });       

        dayOffReasonsForm.onSubmit(async formdata => {
            const resp = (
                await _UTIL.fetchData('insertUpdateDayOffReasonsData', {
                    token: $.session.Token,
                    dayOffReasonsId: rowData ? rowData.dayOffReasonsId : 0,
                    dayOffReasons: formdata.wDayOffReasons,
                    userId: $.session.UserId,
                })
            ).insertUpdateDayOffReasonsDataResult;
            const newID = resp.dayOffReasonsId;
            if (newID == '-1') {
                dayOffReasonsForm.inputs['wDayOffReasons'].setValidtyError('This day off reason already exists.');
                dayOffReasonsForm.inputs['wDayOffReasons'].showError('This day off reason already exists.');
                dayOffReasonsForm.buttons['submit'].toggleDisabled(true);
            } else {
                dayOffReasonsForm.clear();
                POPUP.hide(popup);
                await init();
                updateDayOffReasonsTable();
            }
        });

        dayOffReasonsForm.onCancel(event => {
            dayOffReasonsForm.clear();
            dayOffReasonsForm.buttons['submit'].toggleDisabled(true);
            POPUP.hide(popup);
        });

        dayOffReasonsForm.renderTo(popup);
        POPUP.show(popup);
        dayOffReasonsForm.populate({
            wDayOffReasons: rowData ? rowData.dayOffReasons : '',   
        });

        dayOffReasonsForm.buttons['submit'].toggleDisabled(true);

        if (!$.session.SetupUpdate && rowData) {
            dayOffReasonsForm.disableFormInputs();
        }
    }

    async function handleDayOffReasonsDelete(row) {
        const rowData = dayOffReasonsData.find(a => a.dayOffReasonsId == row.dayOffReasonsId);
        if (rowData.isAccountExistCount == 'Y') {
            showUnableToDeletePopup('This day off reason is used somewhere else in the system.  It cannot be deleted.');
        } else {
            showDeleteConfirmationPopup('Are you sure you want to delete this day off reason?', async deleteRecord => {
                if (deleteRecord) {
                    await _UTIL.fetchData('deleteDayOffReasonsSetup', {
                        token: $.session.Token,
                        dayOffReasonsId: row.dayOffReasonsId,
                    })
                    await init();
                    updateDayOffReasonsTable();
                }
            });
        }
    }
    function updateDayOffReasonsTable() {
        const tableDayOffReasonsData = dayOffReasonsData
            .map(cd => {
                return {
                    values: [cd.dayOffReasons],
                    endIcon: $.session.SetupDelete ? icons['delete'] : '',
                    onClick: e => {
                        showDayOffReasonsPopup(cd);
                    },
                    endIconCallback: () => handleDayOffReasonsDelete(cd),
                };
            });

        table.populate(dayOffReasonsTable, tableDayOffReasonsData);
    }

    function showDeleteConfirmationPopup(message, callback) {
        const popup = POPUP.build({
            classNames: 'setupDeleteConfirmation',
            hideX: true,
        });

        const messageEle = document.createElement('p');
        messageEle.textContent = message;

        const yesBtn = new Button({
            text: 'Yes',
            style: 'primary',
            styleType: 'contained',
        });
        const noBtn = new Button({
            text: 'No',
            style: 'primary',
            styleType: 'outlined',
        });

        yesBtn.onClick(e => {
            POPUP.hide(popup);
            callback(true);
        });
        noBtn.onClick(e => {
            POPUP.hide(popup);
            callback(false);
        });

        const btnWrapEle = document.createElement('div');
        btnWrapEle.classList.add('btn-wrap');
        yesBtn.renderTo(btnWrapEle);
        noBtn.renderTo(btnWrapEle);

        popup.append(messageEle);
        popup.append(btnWrapEle);

        POPUP.show(popup);
    }
    function showUnableToDeletePopup(message) {
        const popup = POPUP.build({
            classNames: 'unableToDeletePopup',
            hideX: true,
        });

        const messageEle = document.createElement('p');
        messageEle.textContent = message;

        const okBtn = new Button({
            text: 'Ok',
            style: 'primary',
            styleType: 'contained',
        });
        okBtn.onClick(e => {
            POPUP.hide(popup);
        });

        popup.append(messageEle);
        okBtn.renderTo(popup);
        POPUP.show(popup);
    }
    function checkForRequiredFields(formInstance) {
        const invalidElements = formInstance.form.querySelectorAll(`
      input:invalid,
      select:invalid,
      textarea:invalid
    `);

        const isFormValid = Array.from(invalidElements).every(field => field.value && field.value.trim() !== '');

        if (!isFormValid) {
            formInstance.buttons['submit'].toggleDisabled(true);
        } else {
            formInstance.buttons['submit'].toggleDisabled(false);
        }
    }

    async function getView(viewName) {
        const viewFragment = document.createDocumentFragment();

        const viewHeading = document.createElement('h1');
        viewHeading.classList.add('viewHeading');
        viewHeading.textContent = viewName;

        const viewBody = document.createElement('div');
        viewBody.classList.add('viewBody');

        let viewMarkup;

        if (viewName === 'Day Off Reasons') {
            await init();
            viewMarkup = getDayOffReasonsView();
        }

        if (viewMarkup) {
            viewFragment.append(viewHeading);
            viewFragment.append(viewBody);
            viewBody.append(viewMarkup);
        }

        return viewFragment;
    }

    async function init() { 
        const dataDayOffReasons = await _UTIL.fetchData('getDayOffReasonsSetupData', {
            token: $.session.Token,
            userId: $.session.UserId,
        });
        dayOffReasonsData = dataDayOffReasons.getDayOffReasonsSetupDataResult;
    }

    return {
        init,
        getView,
    };
})();
